import Vue from 'vue';
import Vuex from 'vuex';
import createPersistedState from 'vuex-persistedstate';
import * as actions from './actions';
import mutations from './mutations';
import menuList from '@/configs/menus';

Vue.use(Vuex);

const store = new Vuex.Store({
  state: {
    categoryTree: [], // 一级分类列表
    categoryForm: {}, // 分类表单数据
    userInfo: {},
    protocol: {},
    menuList, // 菜单列表
    permissionList: [],
    operationList: [], // 页面里面的对应的操作权限列表
    loginData: {}, //登录信息
    addressTree: null // 省市区树
  },
  mutations,
  actions,
  plugins: [createPersistedState()]
});

export default store;